










import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/admin/components/PageHeader.vue'
import __ from '@/shared/helpers/__'
import DataTable from '@/shared/components/data-table/DataTable.vue'
import DataTableBase from '@/shared/classes/components/data-table/data-table'
import DataTableHeader from '@/shared/classes/components/data-table/data-table-header'
import ToolLocation from '@/shared/modules/tool-location/models/tool-location.model'
import ToolLocationService from '@/shared/modules/tool-location/tool-location.service'
import Company from '@/shared/modules/company/company.model'
import { CompanyGetters } from '@/shared/store/company/company.getters'
import { CompanyRoutes } from '@/shared/router/company'
import Can from '@/shared/components/Can.vue'
import permissions from '@/shared/helpers/permissions.helper'
import EditAction from '@/shared/classes/components/data-table/default-actions/edit-action'
import { GlobalActions } from '@/shared/store/global/global.actions'
import DataTableFilter, { FilterOperators } from '@/shared/classes/components/data-table/data-table-filter'
import Field from '@/shared/classes/form/field'
import { FieldTypes } from '@/shared/components/form/field-types'
import DataTableHeaderTypes from '@/shared/classes/components/data-table/data-table-header-types'
import DataTableAction from '@/shared/classes/components/data-table/data-table-action'
import { SnackBarTypes } from '@/shared/helpers/snack-bar.helper'
import User from '@/shared/modules/user/user.model'
import { AuthGetters } from '@/shared/store/auth/auth.getters'
import router from '@/shared/router'

@Component({
    components: { Can, DataTable, PageHeader },
    methods: { __ }
  })
  export default class ToolsLocationsIndex extends Vue {
    permissions = permissions
    table: DataTableBase|null = null

    created() {
      this.table = new DataTableBase()
        .setModel(ToolLocation)
        .setEndpoint(`company/${ this.company.slug }/tool-locations`)
        .setDoubleClick(this.editToolLocation)
        .setHeaders([
          new DataTableHeader()
            .setType(DataTableHeaderTypes.textLink)
            .setKey('name')
            .setText(__('company.views.tool-locations.index.table.columns.location'))
            .setMeta({
              getRawLocation: (tool: ToolLocation) => ({
                path: `${ this.$router.currentRoute.path }/${ tool.uuid }/edit`
              })
            }),
          new DataTableHeader()
            .setKey('quantity')
            .setSortable(false)
            .setText(__('company.views.tool-locations.index.table.columns.quantity'))
        ])
        .setFilters([
          new DataTableFilter()
            .setOperator(FilterOperators.notNulled)
            .setKeyIsPrimary()
            .setField(
              new Field()
                .setType(FieldTypes.checkbox)
                .setKey('deactivated_at')
                .setTitle(__('company.views.tool-locations.index.table.filters.show-deactivated'))
            )
        ])
        .setDefaultFilters([
          {
            operator: FilterOperators.notNulled,
            key: 'deactivated_at',
            value: false,
          }
        ])
        .setActions([
          new EditAction()
            .setPermissions([
              permissions.company.toolLocations.show,
              permissions.company.toolLocations.update,
            ]),
          new DataTableAction()
            .setPermissions([
              permissions.company.toolLocations.deactivate,
            ])
            .setIcon('mdi-delete-outline')
            .setTitle(__('company.views.tools.index.table.actions.deactivate.title'))
            .setAction(async (item: ToolLocation) => {
              await ToolLocationService.deactivate(this.company, item.uuid)

              await this.$store.dispatch(GlobalActions.showSnackBar, {
                type: SnackBarTypes.success,
                message: __('company.views.tool-locations.index.table.actions.deactivate.on-success')
              })

              this.table?.removeItem(item)
            }),
        ])
    }

    navigateToCreate(): void {
      this.$router.push({ name: CompanyRoutes.toolLocationsCreate })
    }

    editToolLocation(item: ToolLocation): void {
      if (this.user.hasDynamicPermissions([permissions.company.toolLocations.show, permissions.company.toolLocations.update])) {
        this.$router.push({ path: `${ router.currentRoute.path }/${ item.uuid }/edit`})
      }
    }

    get company(): Company {
      return this.$store.getters[CompanyGetters.getCompany]
    }

    get user(): User {
      return this.$store.getters[AuthGetters.getUser]
    }
  }
